// extracted by mini-css-extract-plugin
module.exports = {"constructorElementWrapper":"constructor-ingredient-item_constructorElementWrapper__3hPRu"};